import { useThemeMediaQuery } from 'hooks/useThemeMediaQuery'
import {
  ApiIcon,
  AppleIcon,
  Button,
  ButtonVariant,
  CpuIcon,
  DesktopIcon,
  EducationIcon,
  Flex,
  LinuxIcon,
  Text,
  TextVariant,
  VerifyNodeIcon,
  WindowsIcon,
  useModal
} from '@mprolab/uikit'

import { StyledBiennale } from 'components'
import LauncherDownload from 'components/widgets/LauncherDownload/LauncherDownload'
import { InstructionProps } from 'config/types'
import { useRouter } from 'hooks/useRouter'
import React from 'react'
import { isIOS, isAndroid } from 'react-device-detect'
import { Download } from 'react-feather'
import styled, { useTheme } from 'styled-components'

const StyledTitle = styled(StyledBiennale)`
  font-size: 32px;
  white-space: pre-wrap;
  ${({ theme }) => theme.mediaQueries.mobile} {
    font-size: 24px;
  }
`

const ContentBox = styled(Flex)`
  position: relative;
  justify-content: space-between;
  width: 100%;
  flex-direction: column;
  align-items: center;
  height: 311px;
  max-width: 283px;
  padding: 32px 24px 16px 24px;
  background: ${({ theme }) => theme.colors.backgroundContrast};
  ${({ theme }) => theme.mediaQueries.mobile} {
    max-width: 100%;
  }
`

const StyledTextTitle = styled(Text).attrs({ variant: TextVariant.BODY_BIG_MEDIUM })`
  white-space: pre-wrap;
`

const ContentText = styled(Text).attrs({ textAlign: 'center' })`
  color: ${({ theme }) => theme.colors.gray6};
  line-height: 160%;
`

const StepWrapper = styled(Flex)`
  position: absolute;
  opacity: 0.1;
  right: 19px;
  top: -3px;
`

const StepText = styled(Text)`
  font-size: 72px;
  font-weight: 700;
  line-height: 115%;
`

const Instruction: React.FC = () => {
  const { colors } = useTheme()
  const { push } = useRouter()
  const isMobile = useThemeMediaQuery('mobile')
  const isMobileDevice = (isIOS || isAndroid) && isMobile
  const [onPresentLauncherDownload] = useModal(<LauncherDownload />)

  const MGAInstruction: InstructionProps[] = [
    {
      index: 1,
      icon: <Download color={colors.magenta} />,
      title: 'Get your License',
      content: (
        <Flex fullWidth maxWidth="231px">
          <Button disabled={isMobileDevice} size="sm" fullWidth mt="16px" onClick={() => push('/user-licenses')}>
            BUY License
          </Button>
        </Flex>
      )
    },
    {
      index: 2,
      icon: <ApiIcon />,
      title: 'Add License',
      content: <ContentText>Go to Licenses tab on the mprolab website and click the Refresh button.</ContentText>
    },
    {
      index: 3,
      icon: <CpuIcon />,
      title: 'Activate License',
      content: <ContentText>Move Switch Button to activate License. It should turn to green colour.</ContentText>
    },
    {
      index: 4,
      icon: <VerifyNodeIcon />,
      title: 'Done!',
      content: <ContentText>The licence is activated and will take part in the distribution.</ContentText>
    }
  ]

  return (
    <Flex flexDirection="column">
      <Flex alignItems={isMobile ? 'flex-end' : 'center'}>
        <StyledTitle>{`License${isMobile ? `\n` : ' '}setup instruction`}</StyledTitle>
      </Flex>
      <Flex mt={isMobile ? '24px' : '32px'} gap="16px" flexWrap="wrap" justifyContent="center">
        {MGAInstruction.map((instruction) => {
          const { index, icon, title, content, learnMoreHref } = instruction
          return (
            <ContentBox key={index}>
              <StepWrapper>
                <StepText>{index}</StepText>
              </StepWrapper>
              <Flex flexDirection="column" justifyContent="center" alignItems="center" fullWidth>
                <Flex mb="24px">{icon}</Flex>
                <Flex mb="8px" fullWidth justifyContent="center">
                  <StyledTextTitle textAlign="center" variant={TextVariant.BODY_DEFAULT_BOLD}>
                    {title}
                  </StyledTextTitle>
                </Flex>
                <Flex fullWidth justifyContent="center">
                  {content}
                </Flex>
              </Flex>
            </ContentBox>
          )
        })}
      </Flex>
    </Flex>
  )
}

export default Instruction
